<template>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-12">
          <h1 class="m-0">Relatórios</h1>
        </div>
        <!-- /.col -->
        <div class="col-sm-12">
          <ol class="breadcrumb float-sm-left">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item"><a href="/admin/relatorios">Relatórios</a></li>
          </ol>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </div>

  <div>
    <div class="card card-default">
      <div class="card-header">
        <h3 class="card-title" style="color: white">
          <i class="fa-regular fa-file" style="margin-right: 5px"></i>
          Relatórios
        </h3>
      </div>
      <div class="card-body p-3">
        <div class="row">
          <div class="col-sm-12">
            <a href="#" @click="relatorio_selecionado = 'leiloes_em_aberto'">1 - Leilões em aberto (analítico)</a>
          </div>
          <div class="col-sm-12">
            <a href="#" @click="relatorio_selecionado = 'arremate'">2 - Arremate (analítico)</a>
          </div>
          <div class="col-sm-12">
            <a href="#" @click="relatorio_selecionado = 'venda'">3 - Relatório de vendas (analítico)</a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="relatorio_selecionado == 'arremate'">
      <admin-relatorio-arremate :estados="estados" />
    </div>

    <div v-if="relatorio_selecionado == 'venda'">
      <admin-relatorio-venda :estados="estados" />
    </div>

    <!-- FILTROS -->
    <div class="card" v-if="relatorio_selecionado == 'leiloes_em_aberto'">
      <div class="card-header">
        <h5 class="card-title" id="accordion">Filtrar leilões</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-3">
            <div class="form-group">
              <label for="endereco_estado">De</label>
              <input id="dataInicio" class="form-control" name="dataInicio" type="date" v-model="dataInicio" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="endereco_cidade">Até</label>
              <input id="dataFim" class="form-control" type="date" v-model="dataFim" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="comitente">Comitente</label>

              <select class="custom-select rounded-0" id="comitente" v-model="comitente">
                <option value=""></option>
                <option v-for="comitente in comitentes" :key="comitente" :value="comitente.id" style="text-transform: uppercase">
                  {{ comitente.nome }} - {{ comitente.cidade }} / {{ comitente.estado }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="cpf_cnpj">Título</label>
              <input class="form-control" v-model="titulo" style="text-transform: uppercase" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="cpf_cnpj">Descrição do leilão</label>
              <input class="form-control" v-model="descricao" style="text-transform: uppercase" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Listar lotes</label>
              <input style="height: 35px; width: 25px" class="form-control" v-model="listar_lotes" type="checkbox" @change="buscarLeiloes()" />
            </div>
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <button type="button" class="btn btn-primary" @click="buscarLeiloes">Buscar</button>
              <button style="margin-left: 15px" type="button" class="btn btn-default" @click="limparFiltros">Limpar filtros</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button
      v-if="relatorio_selecionado == 'leiloes_em_aberto'"
      style="margin-left: 5px"
      data-dismiss="modal"
      aria-hidden="true"
      @click="print"
      class="btn btn-info"
    >
      Imprimir
      <i style="margin-left: 5px" class="fa-solid fa-print"></i>
    </button>

    <!-- DADOS DO LEILÃO -->
    <div>
      <div
        ref="document"
        style="border-top: solid 2px"
        class="card"
        v-for="(leilao, index) in leiloes"
        :key="leilao"
        v-if="relatorio_selecionado == 'leiloes_em_aberto'"
      >
        <div
          class="card-body p-2"
          style="
            padding: 0px 0px 0px 0px;
            text-align: left;
            font-family: 'Montserrat', sans-serif;
            text-transform: uppercase;
            margin: 0px 0px 0px 0px;
          "
        >
          <div style="text-align: left; line-height: 5px" class="p-2">
            <div style="margin-top: 7px; position: relative">
              <p style="font-size: 16px; font-weight: bold; word-wrap: break-word">
                {{ leilao.cidade }} - {{ leilao.estado }}
                <span
                  class="right badge badge-danger"
                  style="text-transform: uppercase; font-size: 12px; margin-left: 10px"
                  v-if="leilao && leilao.leilao_retirado == 1"
                >
                  Leilão retirado
                </span>
              </p>
              <span style="font-size: 15px; font-weight: bold; margin-top: 4px">
                {{ getFormatedTitle(leilao.leilao_titulo) }}
              </span>
              <br />
            </div>
          </div>

          <div style="line-height: 15px; margin-top: 5px; text-align: left" class="p-2">
            <b style="font-size: 14px">
              Modalidade:
              <a style="font-weight: 400">{{ leilao.leilao_1_modalidade }}</a>
            </b>
          </div>
          <!-- DATAS E VALORES DOS LEILÕES -->
          <div v-if="leilao.leilao_num_pracas > 1 && !venda_direta" style="text-align: left; line-height: 15px" class="p-2">
            <div
              :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
              style="font-size: 14px"
              :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''"
            >
              <b>1º Leilão:&nbsp;</b>
              {{ formatDate(leilao.leilao_1_data) + "h" }}
            </div>

            <!-- DATA 2 -->
            <div
              :style="leilao.leilao_2_realizado === 1 ? 'text-decoration: line-through' : ''"
              style="font-size: 14px"
              v-if="leilao.leilao_num_pracas >= 2"
            >
              <b>2º Leilão:&nbsp;</b>
              {{ formatDate(leilao.leilao_2_data) + "h" }}
            </div>

            <div style="font-size: 14px" v-else><br /></div>

            <!-- DATA 3 -->
            <div
              :style="leilao.leilao_3_realizado === 1 ? 'text-decoration: line-through' : ''"
              style="font-size: 14px"
              v-if="leilao.leilao_num_pracas >= 3"
            >
              <b>3º Leilão:&nbsp;</b>
              {{ formatDate(leilao.leilao_3_data) + "h" }}
            </div>

            <!-- DATA 4 -->
            <div
              :style="leilao.leilao_4_realizado === 1 ? 'text-decoration: line-through' : ''"
              style="font-size: 14px"
              v-if="leilao.leilao_num_pracas >= 4"
            >
              <b>4º Leilão:&nbsp;</b>
              {{ formatDate(leilao.leilao_4_data) + "h" }}
            </div>
          </div>

          <!-- ÚNICO LEILÃO-->
          <div
            v-else-if="leilao.leilao_num_pracas == 1 && !venda_direta"
            style="padding-left: 8px !important; text-align: left; line-height: 15px; margin-top: 5px"
            class="p-1"
          >
            <div style="font-size: 14px; margin-bottom: 3px" :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">
              <b>Único leilão:</b>
              {{ formatDate(leilao.leilao_1_data) + "h" }}
            </div>
          </div>

          <!-- VENDA DIRETA-->
          <div v-else-if="venda_direta" style="text-align: center; line-height: 15px; text-transform: none" class="p-1">
            <p style="font-size: 14px; margin-top: 5px">{{ leilao.leilao_local }}</p>
            <div style="font-size: 14px" :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">
              <b style="">Disponível até:</b>
              {{ formatDate(leilao.leilao_1_data) + "h" }}
              <br />
              <a>Pelo valor de</a>
              R$ {{ toCurrency(lote_selecionado.lote_valor_1) }}
            </div>
          </div>

          <!-- ID DO LEILÃO-->
          <span class="p-2" style="font-size: 15px; font-weight: bold; margin-top: 4px">CÓDIGO DO LEILÃO {{ leilao.id }}</span>

          <!-- HABILITAÇÕES -->
          <button
            style="font-size: 12px; border-radius: 2px; margin-left: 5px"
            type="submit"
            class="btn btn-default"
            data-toggle="modal"
            data-target="#visualizar-habilitacoes"
            @click="leilao_selecionado = leilao"
            title="Habilitações"
            alt="Habilitações"
          >
            <div v-if="leilao.habilitacoes">
              <i class="fa-solid fa-laptop"></i>
              {{ leilao.habilitacoes.length }}
            </div>
            <div v-else>
              <i class="fa-solid fa-laptop"></i>
              0
            </div>
          </button>

          <!-- MODAL LANCES -->
          <div
            class="modal fade"
            id="visualizar-lances"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
            style="margin-top: 30px"
            v-if="lote_selecionado && lote_selecionado.lances && lote_selecionado.lances.length"
          >
            <form @submit.prevent>
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-body" style="font-size: 12px">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h4>Visualizar lances</h4>
                    <br />

                    <!--
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="nome">Lote</label>
                      <select
                        class="custom-select rounded-0"
                        id="leilao_tipo"
                        @change="filtrarLances"
                        v-model="lote_selecionado"
                        style="text-transform: uppercase"
                      >
                        <option value=""></option>
                        <option v-for="lote in lotes" :key="lote" :value="lote">
                          {{ lote.lote_numero }} - {{ getFormatedTitle(lote.lote_titulo) }}
                        </option>
                      </select>
                    </div>
                  </div>
                  -->
                    <button class="btn btn-success" @click="ExportExcel('xlsx')">Download Excel xlsx</button>
                    <div class="card card-primary">
                      <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th>Seq</th>
                              <th>Lote</th>
                              <th>Data/hora</th>
                              <th>Praça</th>
                              <th>Valor</th>
                              <th>Parcelado</th>
                              <th>Apelido</th>
                              <th>Nome</th>
                              <th>Preferencial</th>
                              <th>Nível</th>
                              <th>IP</th>
                              <th>Cancelado</th>
                              <th>Motivo cancelamento</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(lance, index) in lances" :key="lance">
                              <td>{{ index + 1 }}</td>
                              <td>
                                <a :href="'/admin/leilao/' + lance.leilao_id + '/lotes/editar/' + lance.lote_id">
                                  {{ lance.lote_numero }} - {{ getFormatedTitle(lance.lote_titulo) }}
                                </a>
                              </td>
                              <td>{{ formatDate(lance.created_at) }}</td>
                              <td>{{ lance.praca }}</td>
                              <td>{{ getValorLance(lance) }}</td>
                              <td>
                                <p v-if="lance.parcelado && lance.parcelado == 1">Sim</p>
                                <p v-else>Não</p>
                              </td>
                              <td>
                                <a :href="'/admin/cadastros/detalhes/' + lance.lote_lance_user_id">{{ lance.apelido }}</a>
                              </td>
                              <td>
                                <a :href="'/admin/cadastros/detalhes/' + lance.lote_lance_user_id">{{ lance.nome_completo }}</a>
                              </td>

                              <td>
                                <p v-if="lance.igualar_lance && lance.igualar_lance == 1">Sim</p>
                                <p v-else>Não</p>
                              </td>
                              <td>
                                <p v-if="lance.nivel_preferencia">{{ lance.nivel_preferencia }}</p>
                                <p v-else>0</p>
                              </td>
                              <td>{{ lance.ip }}</td>
                              <td>
                                <p v-if="lance.cancelado && lance.cancelado == 1">Sim</p>
                                <p v-else>Não</p>
                              </td>
                              <td>{{ lance.motivo_cancelamento }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div class="card-footer">
                        <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
                      </div>
                    </div>

                    <table class="table table-hover" v-show="false" ref="exportable_table">
                      <thead>
                        <tr>
                          <th>Seq</th>
                          <th>Lote</th>
                          <th>Data/hora</th>
                          <th>Praça</th>
                          <th>Valor</th>
                          <th>Parcelado</th>
                          <th>Apelido</th>
                          <th>Nome</th>
                          <th>Preferencial</th>
                          <th>Nível</th>
                          <th>IP</th>
                          <th>Cancelado</th>
                          <th>Motivo cancelamento</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(lance, index) in lances" :key="lance">
                          <td>{{ index + 1 }}</td>
                          <td>
                            <a :href="'/admin/leilao/' + lance.leilao_id + '/lotes/editar/' + lance.lote_id">
                              {{ lance.lote_numero }} - {{ getFormatedTitle(lance.lote_titulo) }}
                            </a>
                          </td>
                          <td>{{ formatDate(lance.created_at) }}</td>
                          <td>{{ lance.praca }}</td>
                          <td>{{ getValorLanceSemConversao(lance) }}</td>
                          <td>
                            <p v-if="lance.parcelado && lance.parcelado == 1">Sim</p>
                            <p v-else>Não</p>
                          </td>
                          <td>
                            <a :href="'/admin/cadastros/detalhes/' + lance.lote_lance_user_id">{{ lance.apelido }}</a>
                          </td>
                          <td>
                            <a :href="'/admin/cadastros/detalhes/' + lance.lote_lance_user_id">{{ lance.nome_completo }}</a>
                          </td>

                          <td>
                            <p v-if="lance.igualar_lance && lance.igualar_lance == 1">Sim</p>
                            <p v-else>Não</p>
                          </td>
                          <td>
                            <p v-if="lance.nivel_preferencia">{{ lance.nivel_preferencia }}</p>
                            <p v-else>0</p>
                          </td>
                          <td>{{ lance.ip }}</td>
                          <td>
                            <p v-if="lance.cancelado && lance.cancelado == 1">Sim</p>
                            <p v-else>Não</p>
                          </td>
                          <td>{{ lance.motivo_cancelamento }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div style="line-height: 10px"><br /></div>

          <!-- CARD LOTE-->
          <div class="row">
            <div
              class="col-lg-6 col-6 col-md-6 p-0"
              v-if="listar_lotes"
              v-for="lote in leilao.lotes_ordenados"
              :key="lote"
              :value="lote"
              style="text-align: left; border-top: solid 1px"
            >
              <div class="card">
                <div style="padding-left: 25px; margin-top: 10px">
                  <b style="font-size: 12px">
                    LOTE {{ lote.lote_numero + " - " + getFormatedText(lote.lote_titulo, 60) }}

                    <span v-if="lote.lote_status == 'vendido'" class="right badge badge-success" style="font-size: 12px; margin-left: 5px">
                      Lote vendido
                    </span>

                    <span
                      class="right badge badge-success"
                      style="font-size: 12px; background-color: gray; margin-left: 5px"
                      v-if="lote.lote_status == 'sem_licitante'"
                    >
                      Lote sem licitante
                    </span>
                    <span
                      class="right badge badge-success"
                      style="font-size: 12px; background-color: orangered; margin-left: 5px"
                      v-if="lote.lote_status == 'retirado'"
                    >
                      Lote retirado
                    </span>

                    <span class="right badge badge-success" style="font-size: 12px; margin-left: 5px" v-if="lote.lote_situacao == 'desocupado'">
                      Desocupado
                    </span>
                  </b>

                  <!--
                <div style="color: black; font-size: 15px">
                  <p>{{ getLoteDescription(lote.lote_descricao) }}</p>
                </div>
                -->

                  <div style="margin-top: 0px; line-height: 20px">
                    <div v-if="lote.processo">
                      <b style="font-size: 12px">
                        Processo:
                        <a style="font-weight: 500">{{ lote.processo.processo_numero }}</a>
                      </b>
                      <br />
                      <b style="font-size: 12px">
                        Comitente:
                        <a style="font-weight: 500">{{ lote.processo.processo_vara }}</a>
                        <a v-if="lote.processo.cidade" style="font-weight: 500">- {{ lote.processo.cidade.nome }}</a>
                        <a v-if="lote.processo.estado" style="font-weight: 500">- {{ lote.processo.estado.sigla }}</a>
                      </b>
                      <br />
                    </div>

                    <b style="font-size: 12px">
                      Avaliação:
                      <a style="font-weight: 500">R$ {{ toCurrency(lote.lote_avaliacao) }}</a>
                    </b>
                  </div>
                  <!-- DATAS E VALORES DOS LEILÕES -->
                  <div v-if="leilao.leilao_num_pracas > 1 && !venda_direta" style="border-bottom: none; text-align: left; line-height: 15px">
                    <br />
                    <div style="font-size: 12px">
                      <b :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">1º Leilão:&nbsp;</b>
                      <span :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">
                        {{ formatDate(leilao.leilao_1_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_1) }}
                      </span>
                      <span v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 1">&nbsp;- VENDIDO</span>
                    </div>

                    <!-- DATA 2 -->
                    <div style="font-size: 12px" v-if="leilao.leilao_num_pracas >= 2">
                      <b :class="leilao.leilao_2_realizado === 1 ? 'realizado' : ''">2º Leilão:&nbsp;</b>
                      <span :class="leilao.leilao_2_realizado === 1 ? 'realizado' : ''">
                        {{ formatDate(leilao.leilao_2_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_2) }}
                      </span>
                      <span v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 2">&nbsp;- VENDIDO</span>
                    </div>

                    <!-- DATA 3 -->
                    <div style="font-size: 12px" v-if="leilao.leilao_num_pracas >= 3">
                      <b :class="leilao.leilao_3_realizado === 1 ? 'realizado' : ''">3º Leilão:&nbsp;</b>
                      <span :class="leilao.leilao_3_realizado === 1 ? 'realizado' : ''">
                        {{ formatDate(leilao.leilao_3_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_3) }}
                      </span>
                      <span v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 4">&nbsp;- VENDIDO</span>
                    </div>

                    <!-- DATA 4 -->
                    <div style="font-size: 12px" v-if="leilao.leilao_num_pracas >= 4">
                      <b :class="leilao.leilao_4_realizado === 1 ? 'realizado' : ''">4º Leilão:&nbsp;</b>
                      <span :class="leilao.leilao_4_realizado === 1 ? 'realizado' : ''">
                        {{ formatDate(leilao.leilao_4_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_4) }}
                      </span>
                      <span v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 4">&nbsp;- VENDIDO</span>
                    </div>
                  </div>

                  <!-- ÚNICO LEILÃO-->
                  <div
                    v-else-if="leilao.leilao_num_pracas == 1 && leilao.leilao_1_modalidade != 'venda'"
                    style="border-bottom: none; text-align: left; line-height: 20px"
                  >
                    <br />
                    <div style="font-size: 12px; margin-bottom: 3px" :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">
                      <b>Único leilão:&nbsp;</b>
                      {{ formatDate(leilao.leilao_1_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_1) }}
                    </div>
                  </div>

                  <!-- VENDA DIRETA -->
                  <div v-else-if="leilao.leilao_1_modalidade == 'venda'" style="border-bottom: none; text-align: left; line-height: 20px">
                    <br />
                    <div style="font-size: 12px; margin-bottom: 3px" :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''">
                      <b>Disponível até:&nbsp;</b>
                      {{ formatDate(leilao.leilao_1_data) + "h" }} - POR R$ {{ toCurrency(lote.lote_valor_1) }}
                    </div>
                  </div>
                  <div style="margin-bottom: 15px; margin-top: 5px">
                    <!-- PROPOSTAS -->
                    <button
                      style="font-size: 12px; border-radius: 2px"
                      type="submit"
                      class="btn btn-default"
                      title="Propostas"
                      alt="Propostas"
                      @click="(lote_selecionado = lote), (exibir_propostas = true)"
                    >
                      <div v-if="lote.propostas">
                        <i class="fa-solid fa-comment-dollar"></i>
                        {{ lote.propostas }}
                      </div>
                      <div v-else>
                        <i class="fa-solid fa-comment-dollar"></i>
                        0
                      </div>
                    </button>

                    <!-- LANCES -->
                    <button
                      style="font-size: 12px; border-radius: 2px; margin-left: 5px"
                      type="submit"
                      class="btn btn-default"
                      data-toggle="modal"
                      data-target="#visualizar-lances"
                      title="Lances"
                      alt="Lances"
                      @click="(lotes = leilao.lotes_ordenados), (lote_selecionado = lote), (lances = lote.lances)"
                    >
                      <div v-if="lote.lances">
                        <i class="fa-solid fa-gavel"></i>
                        {{ lote.lances.length }}
                      </div>
                      <div v-else>
                        <i class="fa-solid fa-gavel"></i>
                        0
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DADOS DO LEILÃO -->
    <div id="printMe" v-show="false">
      <div
        ref="document"
        style="border-top: solid 2px"
        class="card"
        v-for="(leilao, index) in leiloes"
        :key="leilao"
        v-if="relatorio_selecionado == 'leiloes_em_aberto'"
      >
        <div
          class="card-body p-2"
          style="
            padding: 0px 0px 0px 0px;
            text-align: left;
            font-family: 'Montserrat', sans-serif;
            text-transform: uppercase;
            margin: 0px 0px 0px 0px;
          "
        >
          <div style="text-align: left; line-height: 5px" class="p-2">
            <div style="margin-top: 7px; position: relative">
              <p style="font-size: 16px; font-weight: bold; word-wrap: break-word">
                {{ leilao.cidade }} - {{ leilao.estado }}
                <span
                  class="right badge badge-danger"
                  style="text-transform: uppercase; font-size: 12px; margin-left: 10px"
                  v-if="leilao && leilao.leilao_retirado == 1"
                >
                  Leilão retirado
                </span>
              </p>
              <span style="font-size: 15px; font-weight: bold; margin-top: 4px">
                {{ getFormatedTitle(leilao.leilao_titulo) }}
              </span>
              <br />
            </div>
          </div>

          <div style="line-height: 15px; margin-top: 5px; text-align: left" class="p-2">
            <b style="font-size: 14px">
              Modalidade:
              <a style="font-weight: 400">{{ leilao.leilao_1_modalidade }}</a>
            </b>
          </div>
          <!-- DATAS E VALORES DOS LEILÕES -->
          <div v-if="leilao.leilao_num_pracas > 1 && !venda_direta" style="text-align: left; line-height: 15px" class="p-2">
            <div
              :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
              style="font-size: 14px"
              :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''"
            >
              <b>1º Leilão:&nbsp;</b>
              {{ formatDate(leilao.leilao_1_data) + "h" }}
            </div>

            <!-- DATA 2 -->
            <div
              :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
              style="font-size: 14px"
              v-if="leilao.leilao_num_pracas >= 2"
            >
              <b>2º Leilão:&nbsp;</b>
              {{ formatDate(leilao.leilao_2_data) + "h" }}
            </div>

            <div :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''" style="font-size: 14px" v-else><br /></div>

            <!-- DATA 3 -->
            <div
              :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
              style="font-size: 14px"
              v-if="leilao.leilao_num_pracas >= 3"
            >
              <b>3º Leilão:&nbsp;</b>
              {{ formatDate(leilao.leilao_3_data) + "h" }}
            </div>

            <!-- DATA 4 -->
            <div
              :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
              style="font-size: 14px"
              v-if="leilao.leilao_num_pracas >= 4"
            >
              <b>4º Leilão:&nbsp;</b>
              {{ formatDate(leilao.leilao_4_data) + "h" }}
            </div>
          </div>

          <!-- ÚNICO LEILÃO-->
          <div
            v-else-if="leilao.leilao_num_pracas == 1 && !venda_direta"
            style="padding-left: 8px !important; text-align: left; line-height: 15px; margin-top: 5px"
            class="p-1"
          >
            <div
              :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
              style="font-size: 14px; margin-bottom: 3px"
              :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''"
            >
              <b>Único leilão:</b>
              {{ formatDate(leilao.leilao_1_data) + "h" }}
            </div>
          </div>

          <!-- VENDA DIRETA-->
          <div v-else-if="venda_direta" style="text-align: center; line-height: 15px; text-transform: none" class="p-1">
            <p style="font-size: 14px; margin-top: 5px">{{ leilao.leilao_local }}</p>
            <div
              :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
              style="font-size: 14px"
              :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''"
            >
              <b style="">Disponível até:</b>
              {{ formatDate(leilao.leilao_1_data) + "h" }}
              <br />
              <a>Pelo valor de</a>
              R$ {{ toCurrency(lote_selecionado.lote_valor_1) }}
            </div>
          </div>

          <!-- ID DO LEILÃO-->
          <span class="p-2" style="font-size: 15px; font-weight: bold; margin-top: 4px">CÓDIGO DO LEILÃO {{ leilao.id }}</span>

          <!-- HABILITAÇÕES -->
          <button
            style="font-size: 12px; border-radius: 2px; margin-left: 5px"
            type="submit"
            class="btn btn-default"
            data-toggle="modal"
            data-target="#visualizar-habilitacoes"
            @click="leilao_selecionado = leilao"
            title="Habilitações"
            alt="Habilitações"
          >
            <div v-if="leilao.habilitacoes">
              Habilitações:
              {{ leilao.habilitacoes.length }}
            </div>
            <div v-else>
              <i class="fa-solid fa-laptop"></i>
              0
            </div>
          </button>

          <!-- MODAL LANCES -->
          <div
            class="modal fade"
            id="visualizar-lances"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
            style="margin-top: 30px"
            v-if="lote_selecionado && lote_selecionado.lances && lote_selecionado.lances.length"
          >
            <form @submit.prevent>
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-body" style="font-size: 12px">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h4>Visualizar lances</h4>
                    <br />

                    <!--
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="nome">Lote</label>
                      <select
                        class="custom-select rounded-0"
                        id="leilao_tipo"
                        @change="filtrarLances"
                        v-model="lote_selecionado"
                        style="text-transform: uppercase"
                      >
                        <option value=""></option>
                        <option v-for="lote in lotes" :key="lote" :value="lote">
                          {{ lote.lote_numero }} - {{ getFormatedTitle(lote.lote_titulo) }}
                        </option>
                      </select>
                    </div>
                  </div>
                  -->
                    <button class="btn btn-success" @click="ExportExcel('xlsx')">Download Excel xlsx</button>
                    <div class="card card-primary">
                      <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th>Seq</th>
                              <th>Lote</th>
                              <th>Data/hora</th>
                              <th>Praça</th>
                              <th>Valor</th>
                              <th>Parcelado</th>
                              <th>Apelido</th>
                              <th>Nome</th>
                              <th>Preferencial</th>
                              <th>Nível</th>
                              <th>IP</th>
                              <th>Cancelado</th>
                              <th>Motivo cancelamento</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(lance, index) in lances" :key="lance">
                              <td>{{ index + 1 }}</td>
                              <td>
                                <a :href="'/admin/leilao/' + lance.leilao_id + '/lotes/editar/' + lance.lote_id">
                                  {{ lance.lote_numero }} - {{ getFormatedTitle(lance.lote_titulo) }}
                                </a>
                              </td>
                              <td>{{ formatDate(lance.created_at) }}</td>
                              <td>{{ lance.praca }}</td>
                              <td>{{ getValorLance(lance) }}</td>
                              <td>
                                <p v-if="lance.parcelado && lance.parcelado == 1">Sim</p>
                                <p v-else>Não</p>
                              </td>
                              <td>
                                <a :href="'/admin/cadastros/detalhes/' + lance.lote_lance_user_id">{{ lance.apelido }}</a>
                              </td>
                              <td>
                                <a :href="'/admin/cadastros/detalhes/' + lance.lote_lance_user_id">{{ lance.nome_completo }}</a>
                              </td>

                              <td>
                                <p v-if="lance.igualar_lance && lance.igualar_lance == 1">Sim</p>
                                <p v-else>Não</p>
                              </td>
                              <td>
                                <p v-if="lance.nivel_preferencia">{{ lance.nivel_preferencia }}</p>
                                <p v-else>0</p>
                              </td>
                              <td>{{ lance.ip }}</td>
                              <td>
                                <p v-if="lance.cancelado && lance.cancelado == 1">Sim</p>
                                <p v-else>Não</p>
                              </td>
                              <td>{{ lance.motivo_cancelamento }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div class="card-footer">
                        <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
                      </div>
                    </div>

                    <table class="table table-hover" v-show="false" ref="exportable_table">
                      <thead>
                        <tr>
                          <th>Seq</th>
                          <th>Lote</th>
                          <th>Data/hora</th>
                          <th>Praça</th>
                          <th>Valor</th>
                          <th>Parcelado</th>
                          <th>Apelido</th>
                          <th>Nome</th>
                          <th>Preferencial</th>
                          <th>Nível</th>
                          <th>IP</th>
                          <th>Cancelado</th>
                          <th>Motivo cancelamento</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(lance, index) in lances" :key="lance">
                          <td>{{ index + 1 }}</td>
                          <td>
                            <a :href="'/admin/leilao/' + lance.leilao_id + '/lotes/editar/' + lance.lote_id">
                              {{ lance.lote_numero }} - {{ getFormatedTitle(lance.lote_titulo) }}
                            </a>
                          </td>
                          <td>{{ formatDate(lance.created_at) }}</td>
                          <td>{{ lance.praca }}</td>
                          <td>{{ getValorLanceSemConversao(lance) }}</td>
                          <td>
                            <p v-if="lance.parcelado && lance.parcelado == 1">Sim</p>
                            <p v-else>Não</p>
                          </td>
                          <td>
                            <a :href="'/admin/cadastros/detalhes/' + lance.lote_lance_user_id">{{ lance.apelido }}</a>
                          </td>
                          <td>
                            <a :href="'/admin/cadastros/detalhes/' + lance.lote_lance_user_id">{{ lance.nome_completo }}</a>
                          </td>

                          <td>
                            <p v-if="lance.igualar_lance && lance.igualar_lance == 1">Sim</p>
                            <p v-else>Não</p>
                          </td>
                          <td>
                            <p v-if="lance.nivel_preferencia">{{ lance.nivel_preferencia }}</p>
                            <p v-else>0</p>
                          </td>
                          <td>{{ lance.ip }}</td>
                          <td>
                            <p v-if="lance.cancelado && lance.cancelado == 1">Sim</p>
                            <p v-else>Não</p>
                          </td>
                          <td>{{ lance.motivo_cancelamento }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div style="line-height: 10px"><br /></div>

          <!-- CARD LOTE-->
          <div class="row">
            <div
              class="col-lg-6 col-6 col-md-6 p-0"
              v-if="listar_lotes"
              v-for="lote in leilao.lotes"
              :key="lote"
              :value="lote"
              style="text-align: left; border-top: solid 1px"
            >
              <div class="card">
                <div style="padding-left: 25px; margin-top: 10px">
                  <b style="font-size: 12px">
                    LOTE {{ lote.lote_numero + " - " + getFormatedText(lote.lote_titulo, 60) }}

                    <span v-if="lote.lote_status == 'vendido'" class="right badge badge-success" style="font-size: 12px; margin-left: 5px">
                      Lote vendido
                    </span>

                    <span
                      class="right badge badge-success"
                      style="font-size: 12px; background-color: gray; margin-left: 5px"
                      v-if="lote.lote_status == 'sem_licitante'"
                    >
                      Lote sem licitante
                    </span>
                    <span
                      class="right badge badge-success"
                      style="font-size: 12px; background-color: orangered; margin-left: 5px"
                      v-if="lote.lote_status == 'retirado'"
                    >
                      Lote retirado
                    </span>

                    <span class="right badge badge-success" style="font-size: 12px; margin-left: 5px" v-if="lote.lote_situacao == 'desocupado'">
                      Desocupado
                    </span>
                  </b>

                  <!--
                <div style="color: black; font-size: 15px">
                  <p>{{ getLoteDescription(lote.lote_descricao) }}</p>
                </div>
                -->

                  <div style="margin-top: 0px; line-height: 20px">
                    <div v-if="lote.processo">
                      <b style="font-size: 12px">
                        Processo:
                        <a style="font-weight: 500">{{ lote.processo.processo_numero }}</a>
                      </b>
                      <br />
                      <b style="font-size: 12px">
                        Comitente:
                        <a style="font-weight: 500">{{ lote.processo.processo_vara }}</a>
                        <a v-if="lote.processo.cidade" style="font-weight: 500">- {{ lote.processo.cidade.nome }}</a>
                        <a v-if="lote.processo.estado" style="font-weight: 500">- {{ lote.processo.estado.sigla }}</a>
                      </b>
                      <br />
                    </div>

                    <b style="font-size: 12px">
                      Avaliação:
                      <a style="font-weight: 500">R$ {{ toCurrency(lote.lote_avaliacao) }}</a>
                    </b>
                  </div>
                  <!-- DATAS E VALORES DOS LEILÕES -->
                  <div v-if="leilao.leilao_num_pracas > 1 && !venda_direta" style="border-bottom: none; text-align: left; line-height: 15px">
                    <br />
                    <div style="font-size: 12px">
                      <b
                        :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
                        :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''"
                      >
                        1º Leilão:&nbsp;
                      </b>
                      <span
                        :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
                        :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''"
                      >
                        {{ formatDate(leilao.leilao_1_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_1) }}
                      </span>
                      <span v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 1">&nbsp;- VENDIDO</span>
                    </div>

                    <!-- DATA 2 -->
                    <div style="font-size: 12px" v-if="leilao.leilao_num_pracas >= 2">
                      <b
                        :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
                        :class="leilao.leilao_2_realizado === 1 ? 'realizado' : ''"
                      >
                        2º Leilão:&nbsp;
                      </b>
                      <span
                        :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
                        :class="leilao.leilao_2_realizado === 1 ? 'realizado' : ''"
                      >
                        {{ formatDate(leilao.leilao_2_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_2) }}
                      </span>
                      <span v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 2">&nbsp;- VENDIDO</span>
                    </div>

                    <!-- DATA 3 -->
                    <div style="font-size: 12px" v-if="leilao.leilao_num_pracas >= 3">
                      <b
                        :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
                        :class="leilao.leilao_3_realizado === 1 ? 'realizado' : ''"
                      >
                        3º Leilão:&nbsp;
                      </b>
                      <span
                        :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
                        :class="leilao.leilao_3_realizado === 1 ? 'realizado' : ''"
                      >
                        {{ formatDate(leilao.leilao_3_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_3) }}
                      </span>
                      <span v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 4">&nbsp;- VENDIDO</span>
                    </div>

                    <!-- DATA 4 -->
                    <div style="font-size: 12px" v-if="leilao.leilao_num_pracas >= 4">
                      <b
                        :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
                        :class="leilao.leilao_4_realizado === 1 ? 'realizado' : ''"
                      >
                        4º Leilão:&nbsp;
                      </b>
                      <span
                        :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
                        :class="leilao.leilao_4_realizado === 1 ? 'realizado' : ''"
                      >
                        {{ formatDate(leilao.leilao_4_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_4) }}
                      </span>
                      <span v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 4">&nbsp;- VENDIDO</span>
                    </div>
                  </div>

                  <!-- ÚNICO LEILÃO-->
                  <div
                    v-else-if="leilao.leilao_num_pracas == 1 && leilao.leilao_1_modalidade != 'venda'"
                    style="border-bottom: none; text-align: left; line-height: 20px"
                  >
                    <br />
                    <div
                      :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
                      style="font-size: 12px; margin-bottom: 3px"
                      :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''"
                    >
                      <b>Único leilão:&nbsp;</b>
                      {{ formatDate(leilao.leilao_1_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_1) }}
                    </div>
                  </div>

                  <!-- VENDA DIRETA -->
                  <div v-else-if="leilao.leilao_1_modalidade == 'venda'" style="border-bottom: none; text-align: left; line-height: 20px">
                    <br />
                    <div
                      :style="leilao.leilao_1_realizado === 1 ? 'text-decoration: line-through' : ''"
                      style="font-size: 12px; margin-bottom: 3px"
                      :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''"
                    >
                      <b>Disponível até:&nbsp;</b>
                      {{ formatDate(leilao.leilao_1_data) + "h" }} - POR R$ {{ toCurrency(lote.lote_valor_1) }}
                    </div>
                  </div>
                  <div style="margin-bottom: 15px; margin-top: 5px">
                    <!-- PROPOSTAS -->
                    <button
                      style="font-size: 12px; border-radius: 2px"
                      type="submit"
                      class="btn btn-default"
                      title="Propostas"
                      alt="Propostas"
                      @click="(lote_selecionado = lote), (exibir_propostas = true)"
                    >
                      <div v-if="lote.propostas">
                        Propostas:
                        {{ lote.propostas }}
                      </div>
                      <div v-else>Propostas: 0</div>
                    </button>

                    <!-- LANCES -->
                    <button
                      style="font-size: 12px; border-radius: 2px; margin-left: 5px"
                      type="submit"
                      class="btn btn-default"
                      data-toggle="modal"
                      data-target="#visualizar-lances"
                      title="Lances"
                      alt="Lances"
                      @click="(lotes = leilao.lotes_ordenados), (lote_selecionado = lote), (lances = lote.lances)"
                    >
                      <div v-if="lote.lances">
                        Lances:
                        {{ lote.lances.length }}
                      </div>
                      <div v-else>Lances: 0</div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL HABILITADOS -->
    <div
      class="modal fade"
      id="visualizar-habilitacoes"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
      v-if="leilao_selecionado && leilao_selecionado.habilitacoes && leilao_selecionado.habilitacoes.length"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Visualizar habilitações</h4>
              <br />
              <div class="card card-primary">
                <div class="card-body">
                  <table class="table table-hover text-nowrap">
                    <thead>
                      <tr>
                        <th>Seq</th>
                        <th>Apelido</th>
                        <th>Nome</th>
                        <th>Data da soliticação</th>
                        <th>Status habilitação</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(habilitacao, index) in leilao_selecionado.habilitacoes" :key="habilitacao">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <a :href="'/admin/cadastros/detalhes/' + habilitacao.user_id">{{ habilitacao.apelido }}</a>
                        </td>
                        <td>
                          <a :href="'/admin/cadastros/detalhes/' + habilitacao.user_id">{{ habilitacao.nome_completo }}</a>
                        </td>
                        <td>{{ formatDate(habilitacao.created_at) }}</td>
                        <td>{{ habilitacao.status }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="card-footer">
                  <button data-dismiss="modal" aria-hidden="true" class="btn btn-danger">Fechar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <admin-auditorio-propostas
      v-if="exibir_propostas && lote_selecionado.propostas > 0"
      :leilao="leilao_selecionado"
      :lote_id="lote_selecionado.id"
      :setListarProposta="setListarProposta"
    />
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert.js";
import currencyController from "../../controller/currencyController.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["estados"],

  mixins: [sweetAlert, Swal, AuxController, currencyController],

  components: [Loading],

  data() {
    return {
      isLoading: false,
      leilao_selecionado: "",
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      leiloes: [],
      cidades: [],
      id: "",
      estado: "",
      cidade: "",
      comitente: "",
      venda_direta: false,
      relatorio_selecionado: "",
      listar_lotes: true,
      titulo: "",
      descricao: "",
      dataInicio: "",
      dataFim: "",
      exibir_propostas: false,
      processos: "",
      comitentes: "",
      lote_selecionado: "",
    };
  },

  mounted() {
    console.log(this.docs_tipo_usuario);

    this.dataInicio = this.formatSelectedDate(new Date());

    //this.buscarLeiloes();
    this.buscarComitentes();
    this.buscarprocessos();
  },

  methods: {
    print() {
      const options = {
        name: "Relatório leilão",
        specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
        styles: ["https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css", "https://unpkg.com/kidlat-css/css/kidlat.css"],
        timeout: 1000, // default timeout before the print window appears
        autoClose: true, // if false, the window will not close after printing
        windowTitle: window.document.title, // override the window title
      };

      //htmlToPaper("printMe");

      this.$htmlToPaper("printMe", options);
    },

    formatSelectedDate(date) {
      return moment(date).format("yyyy-MM-DD");
    },

    buscarComitentes() {
      this.isLoading = true;

      let data = {
        inicio: 0,
        tamanho: 100000,
        alfabetico: true,
      };

      axios
        .post(`/admin/comitente/search`, data)
        .then((response) => {
          this.comitentes = response.data.comitentes;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    buscarprocessos() {
      this.isLoading = true;

      let data = {
        inicio: 0,
        tamanho: 100000,
      };

      console.log("Buscando");
      console.log(data);

      axios
        .post(`/admin/processos/search`, data)
        .then((response) => {
          this.processos = response.data.processos;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    setListarProposta() {
      this.exibir_propostas = false;
    },

    getValorLance(lance) {
      return "R$" + this.toCurrency(lance.valor);
    },

    getValorLanceSemConversao(lance) {
      return lance.valor;
    },

    getLoteDescription(description) {
      if (typeof description == "string" && description.includes("</")) {
        //console.log("Entrou no IF");
        var div = document.createElement("div");
        div.innerHTML = description;
        description = div.textContent || div.innerText || "";
      } else {
        // console.log("Descricao fora do IF");
      }

      if (description && description.length > 210) {
        return description.substring(0, 210) + "...";
      }
      return description;
    },

    getFormatedText(text, size) {
      if (text && text.length > size) {
        return text.substring(0, size) + "...";
      } else {
        return text;
      }
    },

    getFormatedTitle(title) {
      if (title && title.length > 30) {
        return title.substring(0, 30) + "...";
      } else {
        return title;
      }
    },

    buscarLeiloes() {
      this.isLoading = true;

      let data = {
        id: this.id,
        comitente_id: this.comitente,
        titulo: this.titulo,
        descricao: this.descricao,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
        executado: this.executado,
      };

      if (this.dataInicio) {
        console.log("Formatando");
        console.log(this.dataInicio);

        data.data_inicio = this.formatDateToSearch(this.dataInicio);
      }

      if (this.dataFim) {
        data.data_fim = this.formatDateToSearchTime(this.dataFim);
      }

      console.log(data);

      axios
        .post(`/admin/leilao/search_em_aberto`, data)
        .then((response) => {
          this.leiloes = response.data.leiloes;
          this.total = response.data.total;

          console.log("Leilões");
          console.log(this.leiloes);

          this.pagination(response.data);
          /*
          //CONVERTER STATUS
          for (let i = 0; i < this.leiloes.length; i++) {
            if (this.leiloes[i].leilao_oculto == 1) {
              this.leiloes[i].leilao_oculto = true;
            } else {
              this.leiloes[i].leilao_oculto = false;
            }

            if (this.leiloes[i].leilao_encerrado == 1) {
              this.leiloes[i].leilao_encerrado = true;
            } else {
              this.leiloes[i].leilao_encerrado = false;
            }

            if (this.leiloes[i].leilao_retirado == 1) {
              this.leiloes[i].leilao_retirado = true;
            } else {
              this.leiloes[i].leilao_retirado = false;
            }

            if (this.leiloes[i].leilao_suspenso == 1) {
              this.leiloes[i].leilao_suspenso = true;
            } else {
              this.leiloes[i].leilao_suspenso = false;
            }

            if (this.leiloes[i].leilao_1_realizado == 1) {
              this.leiloes[i].leilao_1_realizado = true;
            } else {
              this.leiloes[i].leilao_1_realizado = false;
            }

            if (this.leiloes[i].leilao_2_realizado == 1) {
              this.leiloes[i].leilao_2_realizado = true;
            } else {
              this.leiloes[i].leilao_2_realizado = false;
            }

            if (this.leiloes[i].leilao_3_realizado == 1) {
              this.leiloes[i].leilao_3_realizado = true;
            } else {
              this.leiloes[i].leilao_3_realizado = false;
            }

            if (this.leiloes[i].leilao_4_realizado == 1) {
              this.leiloes[i].leilao_4_realizado = true;
            } else {
              this.leiloes[i].leilao_4_realizado = false;
            }
          }
            */
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    formatDateToSearch(date) {
      return moment(date, "yyyy-MM-DD").format("yyyy-MM-DD 00:00:00");
    },

    formatDateToSearchTime(date) {
      return moment(date, "yyyy-MM-DD").format("yyyy-MM-DD 23:59:59");
    },

    changePraca(leilao, num_praca) {
      console.log(leilao.leilao_1_realizado);
      console.log(num_praca);

      this.leilao_selecionado = leilao;

      let valor = -1;

      //FECHANDO PRACA
      if (num_praca == 2 && leilao.leilao_2_realizado && !leilao.leilao_1_realizado) {
        this.showErrorMessageWithButton("Ops...", "A praça anterior não está fechada ainda.");
      } else if (num_praca == 3 && leilao.leilao_3_realizado && !leilao.leilao_2_realizado) {
        leilao.leilao_3_realizado = false;
        this.showErrorMessageWithButton("Ops...", "A praça anterior não está fechada ainda.");
      } else if (num_praca == 4 && leilao.leilao_4_realizado && !leilao.leilao_3_realizado) {
        leilao.leilao_4_realizado = false;
        this.showErrorMessageWithButton("Ops...", "A praça anterior não está fechada ainda.");
      } else {
        if (num_praca == 1) {
          valor = this.convertToTiny(leilao.leilao_1_realizado);
        } else if (num_praca == 2) {
          valor = this.convertToTiny(leilao.leilao_2_realizado);
        } else if (num_praca == 3) {
          valor = this.convertToTiny(leilao.leilao_3_realizado);
        } else if (num_praca == 4) {
          valor = this.convertToTiny(leilao.leilao_4_realizado);
        }

        let data = {
          leilao_id: leilao.id,
          num_praca: num_praca,
          valor: valor,
        };

        console.log(data);

        axios
          .post(`/admin/leilao/fechar_praca`, data)
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              if (response.data.leilao_aberto) {
                leilao.leilao_encerrado = false;
              }

              if (response.data.leilao_encerrado) {
                leilao.leilao_encerrado = true;
              }

              this.showSuccessMessage("Status atualizado");
              this.forceDisconnect();
            } else {
              console.log("Erro na request");
              this.showErrorMessageWithButton("Ops...", response.data.msg);
              this.buscarLeiloes();
            }

            //window.location.reload();
          })
          .catch((error) => {
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
            this.isLoading = false;
          });
      }
    },

    forceDisconnect() {
      let data = {
        leilao_id: this.leilao_selecionado.id,
      };

      axios.post(process.env.MIX_VUE_APP_AUDITORIO + `/emit_disconnect`, data).then((response) => {});
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onRightClick(event, leilao) {
      this.leilao_selecionado = leilao;

      let newMenu = document.getElementById("newMenu");
      let x = event.clientX - 300;
      let y = event.pageY - 250;

      let winWidth = window.innerWidth;
      let cmWidth = newMenu.offsetWidth;

      x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 300 : x;

      console.log("X depois " + x);

      newMenu.style.top = y + "px";
      newMenu.style.left = x + "px";
      newMenu.style.visibility = "visible";
    },

    changeStatus(leilao, atual) {
      console.log(leilao);

      this.leilao_selecionado = leilao;

      let data = {
        leilao_id: leilao.id,
        leilao_retirado: this.convertToTiny(leilao.leilao_retirado),
        leilao_encerrado: this.convertToTiny(leilao.leilao_encerrado),
        leilao_suspenso: this.convertToTiny(leilao.leilao_suspenso),
      };

      console.log(data);

      axios
        .post(`/admin/leilao/atualizar_status`, data)
        .then((response) => {
          this.showSuccessMessage("Status atualizado");
          this.forceDisconnect();

          //window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    ocultarLeilao(leilao) {
      let mensagem = "";

      if (!leilao.leilao_oculto) {
        mensagem =
          "<h3 style='color:#616060'>Ao <b style='color: green'>desocultar</b> o leilão, todos os lotes também serão desocultados. <br/><b>Confirma sua escolha?</b></h3>";
      } else {
        mensagem =
          "<h3 style='color:#616060'>Ao <b style='color: red'>ocultar</b> o leilão, todos os lotes serão marcados com oculto. <br/><b>Confirma sua escolha?</b></h3>";
      }

      this.$swal
        .fire({
          title: mensagem,
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, confirmar!",
        })
        .then((result) => {
          if (result.value) {
            let data = {
              leilao_id: leilao.id,
              leilao_oculto: this.convertToTiny(leilao.leilao_oculto),
            };

            console.log(data);

            axios
              .post(`/admin/leilao/ocultar_leilao`, data)
              .then((response) => {
                this.showSuccessMessage("Status atualizado");

                //window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButton("Ops..", error);
                console.log(error);
                this.isLoading = false;
              });
          } else {
            leilao.leilao_oculto = !leilao.leilao_oculto;
          }
        });
    },

    handler() {
      alert("Right!");
    },

    getUrlImportarLotes(leilao) {
      return "/admin/leilao/" + leilao.id + "/lotes/importar";
    },

    getUrlFotos(leilao) {
      if (leilao.lotes && leilao.lotes.length) {
        return "/admin/fotos/" + leilao.lotes[0].id + "";
      }
    },

    getUrlPub(leilao) {
      return "/admin/publicacao/" + leilao.id + "";
    },

    getUrlDocumentos(leilao) {
      return "/admin/documentos/" + leilao.id + "";
    },

    getUrlListarLotes(leilao) {
      return "/admin/leilao/" + leilao.id + "/lotes";
    },

    getUrlAddLote(leilao) {
      return "/admin/leilao/" + leilao.id + "/lotes/cadastrar_lote";
    },

    getUrlLogs(leilao) {
      return "/admin/leilao/" + leilao.id + "/logs";
    },

    limparFiltros() {
      this.id = "";
      this.estado = "";
      this.cidade = "";
      this.comitente = "";
      this.titulo = "";
      this.descricao = "";
      //this.local = "EXCLUSIVAMENTE ONLINE";
      this.local = "";
      this.tipo = "";
      this.teste = 0;
      this.executado = "";
      this.processo = "";
      this.dataInicio = "";
      this.dataFim = "";

      document.getElementById("dataInicio").value = "";
      document.getElementById("dataFim").value = "";

      //this.buscarLeiloes();
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();
        return ~~days + " dias";
      } else {
        return ~~hours + " horas";
      }
    },

    visualizar(leilao) {
      this.leilao_selecionado = leilao;
    },

    formatToCompare(date) {
      return moment(date);
    },

    convertTiny(value) {
      if (value == 0) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    convertToTiny(value) {
      if (value) {
        return 1;
      } else {
        return 0;
      }
    },

    getUrlEdit(leilao) {
      return "/admin/leilao/" + leilao.id;
    },

    show(leilao) {
      this.leilao_selecionado = leilao;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarLeiloes();
      }
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.estado,
      };

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.cidades = response.data.cidades;

          console.log(response.data);

          this.isLoading = false;

          this.buscarLeiloes();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    getImageLote(lote) {
      if (lote.thumb) {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + lote.thumb.path + "/" + lote.thumb.img;
      } else {
        return "/images/logo.png";
      }
    },

    getImagePath(logo) {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + logo.path + "/" + logo.arquivo;
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarLeiloes();
    },

    deletar(leilao) {
      this.leilao_selecionado = leilao;

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar o tipo de leilao<b><br/>" + this.leilao_selecionado.nome + "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.leilao_selecionado.id,
            };

            axios
              .post(`/admin/leilao/delete`, data)
              .then((response) => {
                this.showSuccessMessage("leilao deletado!");

                window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.leilao_selecionado.id,
        cadastro_tipo: this.leilao_selecionado.cadastro_tipo,
        tipodoc: this.leilao_selecionado.tipodoc,
        estado_civil: this.leilao_selecionado.estado_civil,
        obrigatorio: this.leilao_selecionado.obrigatorio,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/update`, data)
        .then((response) => {
          this.showSuccessMessage("Estilo atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}

.realizado {
  text-decoration: line-through;
}
</style>
